import { useState, useEffect } from 'react';
import { useAuth } from '@/app/Components/AuthProvider';
import { useOnboardingStatus } from './useOnboardingStatus';

export function useOnboardingModal() {
  const { user } = useAuth();
  const { hasCompletedOnboarding, isLoading } = useOnboardingStatus();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    console.log('useOnboardingModal: user:', user?.id, 'isLoading:', isLoading, 'hasCompletedOnboarding:', hasCompletedOnboarding);
    
    // Only show modal if user is authenticated, onboarding check is complete, and they haven't completed onboarding
    if (user && !isLoading && hasCompletedOnboarding === false) {
      console.log('useOnboardingModal: Showing modal');
      setShowModal(true);
    } else {
      console.log('useOnboardingModal: Hiding modal');
      setShowModal(false);
    }
  }, [user, isLoading, hasCompletedOnboarding]);

  const closeModal = () => {
    setShowModal(false);
  };

  return {
    showModal,
    closeModal,
    isLoading
  };
}
